export const VENDORS__UPDATE_SINGLE_USER_VENDOR_RULE =
  'VENDORS__UPDATE_SINGLE_USER_VENDOR_RULE';
export const VENDORS__UPDATE_MULTIPLE_USER_VENDOR_RULES =
  'VENDORS__UPDATE_MULTIPLE_USER_VENDOR_RULES';
export const VENDORS__DELETE_SINGLE_USER_VENDOR_RULE =
  'VENDORS__DELETE_SINGLE_USER_VENDOR_RULE';
